export default __webpack_public_path__ + "static/media/o11.30d501aa.jpg";